import { PropsWithChildren } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

import { StandardButton } from "./StandardButton"

const useStyles = makeStyles()((theme) => ({
    addButton: {
        "&.MuiButton-root": {
            height: "3rem",
            padding: ".75rem 1rem",
            borderRadius: ".625rem",
            border: `.125rem dashed ${theme.palette.tailwind.slate[300]}`,
            backgroundColor: "transparent",
            color: theme.palette.tailwind.blue[500],
            fontSize: ".875rem",
            fontWeight: 500,
            justifyContent: "flex-start",
        },
        "&.MuiButton-root:hover": {
            borderColor: theme.palette.tailwind.blue[500],
            backgroundColor: "transparent",
        },
        "& .MuiButton-startIcon svg": {
            fontSize: "1.125rem",
        },
    },
    addButtonCard: {
        "&.MuiButton-root": {
            width: "100%",
            height: "100%",
            minHeight: "9.75rem",
            justifyContent: "center",
        },
    },
}))

export enum DashedAddButtonVariant {
    ROW = "row",
    CARD = "card",
}

type Props = Readonly<
    PropsWithChildren<{
        onClick: () => void
        variant?: DashedAddButtonVariant
        className?: string
    }>
>

export function DashedAddButton({ onClick, variant = DashedAddButtonVariant.ROW, className, children }: Props) {
    const { classes, cx } = useStyles()

    return (
        <StandardButton
            fullWidth={variant === DashedAddButtonVariant.ROW}
            size="small"
            variant="outlined"
            className={cx(
                classes.addButton,
                variant === DashedAddButtonVariant.CARD && classes.addButtonCard,
                className,
            )}
            startIcon={<FontAwesomeIcon icon={faPlus} />}
            onClick={onClick}
        >
            {children}
        </StandardButton>
    )
}
